import { Breadcrumb, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import constants from '../../Constants/constants';
import { COOKIE, getCookie } from '../../Services/Cookie';

const Breadcrumbs = ({ routes, additionalTitle = '', additionalBreadcrumbs = [], isArchived = false }) => {
  const [items, setItems] = useState([]);
  const [currentPageTitle, setCurrentPageTitle] = useState('')
  useEffect(() => {
    setBreadcrumbItems()
  }, [routes, additionalTitle])

  const setBreadcrumbItems = () => {
    let breadcrumbItems = [{
      title: constants.Dashboard,
      path: getCookie(COOKIE.Role) !== '0' ? '/dashboard' : '/student-dashboard',
    }];

    let filteredAdditionalBreadcrumbs = []
    if (additionalBreadcrumbs && additionalBreadcrumbs.length > 0) {
      filteredAdditionalBreadcrumbs = additionalBreadcrumbs.filter(
        (breadcrumb) => !routes.some((route) => route?.title === breadcrumb?.title)
      );
      breadcrumbItems = [...breadcrumbItems, ...filteredAdditionalBreadcrumbs];
    }

    if (routes && routes.length > 0) {
      breadcrumbItems = [...breadcrumbItems, ...routes];
    }

    breadcrumbItems = Array.from(
      new Map(breadcrumbItems.map(item => [item.title, item]))?.values()
    );

    setItems(breadcrumbItems);
    setCurrentPageTitle(breadcrumbItems[breadcrumbItems.length - 1]?.title);
  }

  function itemRender(currentRoute, params, items, paths) {
    const isLast = currentRoute?.path === items[items.length - 1]?.path;

    return isLast ? (
      <span>{currentRoute.title}</span>
    ) : (
      <Link to={currentRoute?.path} state={currentRoute?.state || {}}>{currentRoute.title}</Link>
    );
  }

  return (
    <div className="d-flex align-items-lg-center justify-content-between flex-lg-row flex-column !mb-0 lg:!mb-3">
      <h4 className="mb-lg-0">
        {`${currentPageTitle} ${additionalTitle && ` - ${additionalTitle}`}`}
        {isArchived && <Tag bordered={false} color='#337ab7'>{constants.Archived}</Tag>}
      </h4>
      <Breadcrumb
        className='hidden lg:block'
        items={items}
        itemRender={itemRender}
      />
    </div>
  );
}

export default Breadcrumbs;